import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from 'utils/constants';
import { useAxios } from 'providers/AxiosProvider';

export interface LocationDetail {
  id?: number;
  name: string;
  region: string;
  country: string;
  lat: number;
  lon: number;
  localtime?: string;
  localtime_epoch?: number;
  tz_id?: string;
  url?: string;
}

export const useGetLocations = (criteria: string) => {
  const axios = useAxios();
  const searchCriteria = criteria.trim();
  const isEnabled = !!searchCriteria && searchCriteria.length > 2;

  const getLocations = async (criteria: string): Promise<LocationDetail[]> => {
    const response = await axios.request({
      url: `/api/forecasts/search?q=${criteria}`,
    });

    return response.data;
  };

  return useQuery({
    queryKey: [QueryKeys.Locations, searchCriteria],
    queryFn: () => getLocations(searchCriteria),
    enabled: isEnabled,
    staleTime: 1000 * 60 * 60 * 24, // 24h
  });
};
